import { ExperienceConfig, CreateExperienceResponse, GetExperienceResponse } from '../shared/types';

class ExperienceServiceReal {
    private API_URL = '/api/experience';

    async createExperience(config: Omit<ExperienceConfig, 'id' | 'createdAt' | 'paymentStatus' | 'isActive'>): Promise<CreateExperienceResponse> {
        try {
            const response = await fetch(this.API_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(config),
            });
            const data = await response.json() as CreateExperienceResponse;
            if (!data.success) {
                console.error('API Error Details:', data);
            }
            return data;
        } catch (error) {
            console.error('Create Experience Error:', error);
            return { success: false, error: 'Network error occurred' };
        }
    }

    async getExperienceBySubdomain(subdomain: string): Promise<GetExperienceResponse> {
        try {
            const response = await fetch(`${this.API_URL}?subdomain=${encodeURIComponent(subdomain)}`);

            if (!response.ok) {
                if (response.status === 404) {
                    return { success: false, error: 'Experience not found' };
                }
                const errorData = await response.json() as any;
                return { success: false, error: errorData.error || 'Failed to fetch experience' };
            }

            return await response.json();
        } catch (error) {
            console.error('Get Experience Error:', error);
            return { success: false, error: 'Network error occurred' };
        }
    }
}

export const ExperienceService = new ExperienceServiceReal();
